import React from 'react'
import { useIntl } from 'react-intl'
import { OrderAccessRole } from 'components/Common/OrderView/OrderItemSummaries/shareOrder/types'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import LineEyeIcon from 'LuxKit/Icons/line/LineEyeIcon'
import LineEditAltIcon from 'LuxKit/Icons/line/LineEditAltIcon'
import SubDetail from './SubDetail'

interface Props {
  order: App.Order
  hideSharedBy?: boolean
}

function SharedAccessTag({ order, hideSharedBy = false }: Props) {
  const intl = useIntl()
  const { accessDetails, customerFullName } = order

  const { role, isSharedUser } = accessDetails

  if (!isSharedUser) {
    return null
  }

  return (
    <>
      {role === OrderAccessRole.VIEWER && (
        <SubDetail variant="medium">
          <StatusLabel
            variant="confirmation"
            startIcon={<LineEyeIcon />}
          >
            {intl.formatMessage({
              id: 'g3vd3Xj2pJ',
              defaultMessage: 'View Access',
              description: 'Label indicating the user has view-only access to a shared booking',
            })}
          </StatusLabel>
        </SubDetail>
      )}

      {role === OrderAccessRole.MANAGER && (
        <SubDetail variant="medium">
          <StatusLabel
            variant="confirmation"
            startIcon={<LineEditAltIcon />}
          >
            {intl.formatMessage({
              id: 'e1UoKPZPs0',
              defaultMessage: 'Edit Access',
              description: 'Label indicating the user has edit access to a shared booking',
            })}
          </StatusLabel>
        </SubDetail>
      )}

      {!hideSharedBy && (
        <SubDetail variant="medium">
          {intl.formatMessage(
            {
              id: 'w7VATNu0zK',
              defaultMessage: 'Shared by {customerFullName}',
              description: 'Text showing who shared the booking with the current user',
            },
            { customerFullName },
          )}
        </SubDetail>
      )}
    </>
  )
}

export default SharedAccessTag
